import React from "react";
import { FeedPostDataCells } from "./FeedPostDataCells";
import { FeedPostsTable } from "./FeedPostsTable";
import { RecentlyViewedCarousel } from "./RecentlyViewedCarousel";
import { PageTitle } from "@/components/PageTitle";
import { useTranslation } from "react-i18next";

export const FeedPostOverview = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t("feedPost.title")} className="border-b" />
      <div className="flex flex-col gap-6 p-6">
        <FeedPostDataCells />
        <RecentlyViewedCarousel />
        <div className="pt-2">
          <FeedPostsTable />
        </div>
      </div>
    </>
  );
};
